import { render, staticRenderFns } from "./ReviewNextNote.vue?vue&type=template&id=382ab374"
import script from "./ReviewNextNote.vue?vue&type=script&lang=js"
export * from "./ReviewNextNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports